import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <div className={styles.logo}>
          <img src="/logo.svg" alt="Logo" style={{ width: '40px', height: '40px', marginRight: '10px' }} />
          <div>
            <p className={styles.logoName}>{t('footer.name')}</p>
            <p className={styles.logoSub}>{t('footer.subtitle')}</p>
          </div>
        </div>
        <p className={styles.address}>{t('footer.address')}</p>
      </div>
      <div className={styles.right}>
        <p className={styles.copy}>© {new Date().getFullYear()} All rights reserved</p>
        <p className={styles.links}>
          <a href="#hero">{t('footer.privacy')}</a> · <a href="#hero">{t('footer.terms')}</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
